<template>
<div class="quote-box wrap clearfix" :class="{'wrap-dfm':isInDFM}">
	<div class="quote-title" :class="{'title-fixed':isFixed && !isMinWidth}">
		<div v-show="stay=='pcb' || stay=='smt' || stay=='smd'" class="quote-title-content">
			<span>{{ stay=='pcb' ? LANG.pcb_quote : (stay=='smt' ? LANG.pcb_assembly_quote : LANG.stencil) }}</span>
			<a href="/quote-by-sales" target="_blank" class="quote-sale-btn fs-md"><i class="icon icon-salemant mg-r-xs">&#xe6c9;</i>{{ LANG.quote_by_salesperson }}</a>
		</div>
	</div>
	<div class="quote-content">
		<slot></slot>
			
		<div v-if="(['pcb'].includes(stay) && relation =='') || (stay=='smt' && smtStep == 0)" class="change-box">
			<div class="change-content" :class="{'cursor':stay=='pcb'}" @click.stop="handlePcbClick">
				<div class="change-content-left">
					<np-checkbox v-if="stay=='pcb'"  v-model="isSmt" :val="isSmt" @change="handleChangeType"></np-checkbox>	
					<b><template v-if="stay=='pcb'">Add</template> PCB Assembly</b>
					<a v-if="stay=='pcb'" href="/blog/Free-PCB-Assembly" target="_blank">Free assembly for 5 pieces</a>
					<i v-if="stay=='pcb'" class="sale-icon">promo</i>
				</div>
				<div class="change-content-right">
					<a v-if="stay=='pcb'" class="next-btn" :class="{'next-btn-main':isSmt}" @click.stop="handleGoPcbToSmt">Continue
						<i class="icon fs-sm mg-l-sm">
							&#xe61f;
						</i>
					</a>
					<div v-if="stay=='smt' && smtStep == 0" style="display:flex;">
						<a class="next-btn next-btn-default mr-20" @click.stop="handleSmtToPcb">Only PCB</a>
						<a class="next-btn next-btn-main" @click.stop="handleSmtNext">Next Step
							<i class="icon fs-sm mg-l-sm">
								&#xe61f;
							</i>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- quote aside -->	
	<quote-aside v-if="stay!=='smt'"></quote-aside>
	<quote-newaside v-else></quote-newaside>
</div>
</template>
<script>

import quoteAside from '@/components/quote/quote_aside.vue'
import quoteNewaside from '@/components/quote/quote_newaside.vue'
import npCheckbox from '@/_module/checkbox/index.vue'
export default {
	name: 'fpc_quote',
	data(){
		return {
			isSmt: false
		}
	},
	computed: {
		stay(){
			return this.$store.state.quote.stay;
		},
		isInDFM(){
			if(window.isInDFM){
				return JSON.parse(window.isInDFM)
			}
			else{
				return false
			}
		},
		isFixed(){
			return this.$store.state.isFixed
		},
		isMinWidth(){
			return this.$store.state.isMinWidth
		},
		pcbParams(){
			return this.$store.getters.getQuotepcb_params
		},
		smtStep(){
			return this.$store.getters.getSmtquoteOn
		},
		relation(){
			return this.$store.state.quote.relation;
		},
	},
	watch:{
		
	},
	components: {
		'quote-aside':quoteAside,
		'quote-newaside':quoteNewaside,
		'np-checkbox': npCheckbox
	},
	mounted(){
		window.scroll({top:0, left:0 , behavior: 'smooth'})
	},
	methods:{
		handleChangeType(e){
			this.isSmt = !!this.isSmt
		},
		handlePcbClick(){
			if(this.stay !='pcb'){
				return
			}
			console.log('handlePcbClick')
			this.isSmt = !this.isSmt
			if(this.isSmt){
				try {
					window.dataLayer.push({ event: 'PCBPageTickEvent' })
				} catch (error) {
					
				}
			}

		},
		handleGoPcbToSmt(){
			if(!this.isSmt){
				return false
			}

			this.$store.commit("setsmtQuoteOn", 1)
			this.$store.commit("setQuoteValuation", null)
			this.$store.commit("setChangeType", true)
			this.$store.commit("setIsStepClick", false)
			this.$store.commit("setIsFromPcb", true)
			const newUrl = location.href.split('#')[0].replace('pcb-quote','pcb-assembly-quote')
			history.replaceState(null, '', newUrl)
			window.sessionStorage.setItem('pcbParams',JSON.stringify(this.pcbParams))
			this.$router.replace('/pcb-assembly-quote')
		},
		handleSmtNext(){
			this.$store.commit("setsmtQuoteOn",1)
			window.scroll({top:0, left:0 , behavior: 'smooth'})
		},
		handleSmtToPcb(){
			this.$store.commit("setQuoteValuation", null)
			this.$store.commit("setChangeType", true)
			this.$store.commit("setQuoteRelation","");
			this.$store.commit("setIsStepClick", false)
			const newUrl = location.href.split('#')[0].replace('pcb-assembly-quote','pcb-quote')
			history.replaceState(null, '', newUrl)
			window.sessionStorage.setItem('pcbParams',JSON.stringify(this.pcbParams))
			this.$router.replace('/pcb-quote')
		}
	}
}
</script>
<style lang="scss">
@import "@/assets/quote/quote.scss";
.quote-content {
	float: left;
	width: 68.3333%;
	box-sizing: border-box;
}
.quote-title {
	font-size: 20px;		
	color: #333;
	font-weight: bold;
	height: 60px;
	line-height: 60px;
}
.quote-title-content {
	display: flex;
	justify-content: space-between;
	width: 820px;
}
.quote-sale-btn {
	padding-top: 12px;
	color: #333;
	cursor: pointer;
}

.title-fixed{
	width: 1200px;
	position: fixed;
	left: 50%;
	top: 48px;
	transform: translateX(-50%);
	background-color: #f2f2f2;
	z-index: 100;
}

.change-box{
	width: 100%;
	box-sizing: border-box;
	padding: 20px;
	background: #FFF;
	.change-content{
		width: 100%;
		height: 60px;
		box-sizing: border-box;
		padding: 0 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #f2f2f2;

		&-left{
			display: flex;
			align-items: center;
			flex: 1;
			.np-checkbox{
				width: 22px;
				height: 22px;
				margin-right: 10px;

				.np-checkbox-style{
					border-width: 2px;
				}

				.np-checkbox-style::after{
					top: 3px;
					left: 2px;
					width: 13px;
					height: 5px;
					border-left: 3px solid #fff;
					border-bottom: 3px solid #fff;
				}
			}

			b {
				font-size: 20px;
				font-weight: 700;
			}

			a{
				margin-left: 10px;
    		color: #b8802c;
			}

			.sale-icon {
        display: inline-block;
        background: #ff9900;
        height: 18px;
        line-height: 14px;
        border-radius: 2px;
        color: #ffffff;
        padding: 0 4px;
        font-size: 12px;
				margin-left: 10px;
				// vertical-align: 2px
      }
		}
	}
}

.cursor{
	cursor: pointer;
}

.next-btn{
	width: 106px;
	height: 32px;
	background: #ccc;
	border: none;
	border-radius: 4px;
	font-size: 14px;
	color: #FFFFFF;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 32px;
	cursor: not-allowed;
}

.next-btn-main{
	background: #C00;
	cursor:pointer;
}

.next-btn-default{
	background: #FFF;
	border: 1px solid #ccc;
	color: #333;
	cursor:pointer;
	margin-right: 20px;

	&:hover{
		border-color: #C00;
		color: #C00;
	}
}
</style>
